import useApi from "./useApi";

const EMPTY_DATA = {
  total_orders: 0,
  total_products: 0,
  total_customers: 0,
  top_products: [],
  top_customers: [],
};

const useVendorDashboard = () => {
  const { get } = useApi();

  const { data, isLoading, isError, error } = get("/vendor-dashboard");

  return {
    data: data?.data ?? EMPTY_DATA,
    isLoading,
    isError,
    error,
  };
};

export default useVendorDashboard;
